import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { Sort, SortDirection } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { EnrichedProgrammingFile } from 'src/entities/file';

@Component({
  selector: 'app-file-programming-table',
  templateUrl: './file-programming-table.component.html',
  styleUrls: ['./file-programming-table.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileProgrammingTableComponent implements OnChanges {
  @Input() displayedColumns: string[] = [];
  @Input() files: EnrichedProgrammingFile[] = [];
  @Input() pageIndex = 0;
  @Input() pageSize = 10;
  @Input() paginatorLength = 0;
  @Input() isFiltering = false;
  @Input() isLoading = false;
  @Input() isMergingData = false;
  @Input() loadingMessage = '';
  @Input() skeletonRows: null[] = [];
  @Input() sortActive: 'updatedAt' | 'startDateFile' = 'updatedAt';
  @Input() sortDirection: SortDirection = 'desc';
  @Input() canChangeFileState: (file: EnrichedProgrammingFile) => boolean = () => false;

  @Output() changeFileState = new EventEmitter<EnrichedProgrammingFile>();
  @Output() openCsReview = new EventEmitter<EnrichedProgrammingFile>();
  @Output() openFile = new EventEmitter<EnrichedProgrammingFile>();
  @Output() openFlights = new EventEmitter<string | null | undefined>();
  @Output() openPassengers = new EventEmitter<EnrichedProgrammingFile>();
  @Output() openPreOperationalIncidents = new EventEmitter<EnrichedProgrammingFile>();
  @Output() pageChange = new EventEmitter<PageEvent>();
  @Output() refresh = new EventEmitter<void>();
  @Output() sortChange = new EventEmitter<Sort>();

  dataSource = new MatTableDataSource<EnrichedProgrammingFile>();

  constructor(private readonly cdRef: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['files']) {
      this.syncTableData();
    }
  }

  readonly trackById = (_: number, file: EnrichedProgrammingFile) => file.id;

  get visibleCount(): number {
    return this.files.length;
  }

  getMainGuideName(file: EnrichedProgrammingFile): string {
    return file.mainGuideName ?? '';
  }

  getStateActionIcon(file: EnrichedProgrammingFile): string {
    return this.canChangeFileState(file) ? 'pencil' : 'info-circle';
  }

  getStateActionTooltip(file: EnrichedProgrammingFile): string {
    return this.canChangeFileState(file)
      ? 'Cambiar estado desde Operations'
      : 'Ver información del estado';
  }

  private syncTableData(): void {
    this.dataSource.data = this.files;
    this.cdRef.markForCheck();
  }
}
